/**
 * A SEGMENTED CONTROL'S KEYS, as carbon's `SegmentedControl` (SegmentedControl.tsx:72-80): Right / Down choose the next
 * segment and Left / Up the previous one, wrapping at either end. Any other key is not the control's: null.
 */
export function nextSegment(key: string, index: number, count: number): number | null {
  const step = key === 'ArrowRight' || key === 'ArrowDown' ? 1 : key === 'ArrowLeft' || key === 'ArrowUp' ? -1 : 0;
  return step && count > 0 ? (index + step + count) % count : null;
}
